import * as React from "react";
import axios from "axios";
import AxiosConfig from "../../utilities/AxiosConfig";
import CollapsibleArea from "../../components/common/CollapsibleArea";
import { Button, FormControl, Modal, OverlayTrigger, Popover, Spinner, Table } from "react-bootstrap";
import { Tooltip as ReactTooltip } from "react-bootstrap";
import TextInput from "../../components/common/TextInput";
import { LedgerReferenceType, LedgerType, PTOSnapshotType, TimeAdminReferenceType, CalendarConflictType, PtoType, PTOArchiveType } from "./types";
import ErrorBoundary from "../../components/common/ErrorBoundary";
import Loader from "../../components/common/Loader";
import { connect } from "react-redux";
import { AppState } from "../../store";
import { highlightTableRowById } from "../../utilities/helper/animations";
import dayjs from "dayjs";
import PTORequestTable from "./PTORequestTable";
import AddRequest from "./AddRequest";
import EditRequest from "./EditRequest";
import moment from "moment";
import Select from "react-select";
import LedgerYearFilterSelect from "src/components/pto/LedgerYearFilterSelect";
import LedgerStatusChange from "src/components/pto/LedgerStatusChange";
import PTODeletePrompt from "src/components/pto/PTODeletePrompt";
import PTOApprovalError from "src/components/pto/PTOApprovalError";
import CreateDatePopover from "src/components/pto/CreateDatePopover";
import PTOShowComment from "src/components/pto/PTOShowComment";
import CalendarConflictWarningList from "src/components/pto/CalendarConflictWarningList";
import { shouldAllowAccess } from "src/utilities/helper";
import ReferenceTypes from "src/store/UserReference/types";
import EmployeeBadge from "src/components/common/EmployeeBadge";
import "./AddRequest.css";
import "./ManageDetail.css";
import StaticInfoPanel from "./StaticInfoPanel/StaticInfoPanel";

var utc = require("dayjs/plugin/utc")
dayjs.extend(utc)

type PtoErrorType = {
    date: any,
    errorMessage: string


}

interface IProps {
    details: any;
    handleClose: any;
    reference?: TimeAdminReferenceType | null;
    ledgerReference?: {
        ledgerEntryTypes: Array<LedgerReferenceType>;
        ledgerStatusTypes: Array<LedgerReferenceType>;
    },
    userId: string | number;
    updateTable: any;
    hideHeader?: boolean
    toggleModal?: any;
    isModal?: boolean;
    toggleVertical: any;
    isVertical: boolean;
    //bk 4/14/2022
    userReference: ReferenceTypes
}
// const thisYear = new Date().getFullYear();
// const currentYearStart = moment(`1/1/${thisYear} GMT+001:00`)

const ManageDetail: React.FC<IProps> = (props: IProps) => {
    const { details, handleClose, userId, toggleModal, toggleVertical, isVertical, } = props;
    const isOwnPTO = Number(userId) === Number(details.UserId);
    const [ArchivedPTO, setArchivedPTO] = React.useState([] as PTOArchiveType[])
    // const [employeeOpen, setEmployeeOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [refreshing, setRefreshing] = React.useState(false);
    const [ptoSnapshot, setPtoSnapshot] = React.useState({} as PTOSnapshotType)
    const [userInfo, setUserInfo] = React.useState({} as any);
    const [ptoData, setPtoData] = React.useState({} as PtoType);
    const [usersPTOPlan, setUsersPTOPlan] = React.useState({} as any);
    //? Add and edit states
    const [isUpdating, setIsUpdating] = React.useState(false);
    const [addLedgerOpen, setAddLedgerOpen] = React.useState(false);
    const editLedgerForm: any = React.useRef(null);
    const [ledgerEdit, setLedgerEdit] = React.useState(null as LedgerType | null);
    const [showPtoWarningAlert, setShowPtoWarningAlert] = React.useState(false);
    const [hasPtoPlan, setHasPtoPlan] = React.useState(false);
    const [showMissingPtoPlanModal, setShowMissingPtoPlanModal] = React.useState(false);
    const [loaded, setLoaded] = React.useState(false);
    const [dateSort, setDateSort] = React.useState(false);
    const [fromToDate, setFromToDate] = React.useState<number | null>(null);
    //r-18-lint-cm
    //eslint-disable-next-line
    const [ledgerEntryTypes, setLedgerEntryTypes] = React.useState(props.ledgerReference?.ledgerEntryTypes);
    const [entryType, setEntryType] = React.useState({ label: "All", value: -1 });
    const [showApproveAllModal, setShowApproveAllModal] = React.useState(false);
    const [userLoading, setUserLoading] = React.useState(false);
    const [ptoDataLoaded, setPtoDataLoaded] = React.useState(false);
    //r-18-lint-cm
    //eslint-disable-next-line
    const [hoursToApprove, setHoursToApprove] = React.useState(0);
    const [showLedgerStatusChangeModal, setShowLedgerStatusChangeModal] = React.useState(false);
    const [ledgerStatusChangeType, setLedgerStatusChangeType] = React.useState("")
    const [entryToEdit, setEntryToEdit] = React.useState({} as LedgerType)
    //r-18-lint-cm
    //eslint-disable-next-line
    const [saving, setSaving] = React.useState(false);
    const [showContactSupportMessage, setShowContactSuportMessage] = React.useState(false);
    const [showPtoStatusChangeModal, setShowPtoStatusChangeModal] = React.useState(false);
    const [showPTODeletePrompt, setShowPTODeletePrompt] = React.useState(false);
    //r-18-lint-cm
    //eslint-disable-next-line
    const [deletePTOEntry, setDeletePTOEntry] = React.useState(false);
    const [entryToDelete, setEntryToDelete] = React.useState({} as LedgerType)
    const [requestString, setRequestString] = React.useState("");
    const [showPTOErrorMessage, setShowPTOErrorMessage] = React.useState(false);
    const [ptoApprovalErrorList, setPTOApprovalErrorList] = React.useState<PtoErrorType[]>();
    const [ptoRequestConflicts, setPTORequestConflicts] = React.useState<any[]>();
    //r-18-lint-cm
    //eslint-disable-next-line
    const [isHrAdmin, setIsHRAdmin] = React.useState(shouldAllowAccess("HR:ADMIN"));
    //@ts-ignore
    let sortableData: LedgerType[] | null | undefined = ptoData?.ledger;
    let sortableDataCopy: LedgerType[];
    //r-18-lint-cm
    //eslint-disable-next-line
    let totalHours: number = 0;
    let conflictArray: any[] = [];

    const requested = ptoSnapshot.TotalHoursPending ? ptoSnapshot.TotalHoursPending < 0 ? -1 * (ptoSnapshot.TotalHoursPending + ptoSnapshot.TotalUnpaidHoursPending) : ptoSnapshot.TotalHoursPending : 0
    const canApprove = requested > 0 ? true : false

    const getPtoInfo = () => {
        // let time = performance.now();
        axios.get(process.env.REACT_APP_API_URL + `/api/pto/detail/${details.UserId}`, AxiosConfig.configValue())
            .then((res: any) => {
                setPtoData(res.data?.detail);
                setPtoDataLoaded(true);
            })
            .catch((err: any) => {
                AxiosConfig.handleError(err);
            })
            .finally(() => {
                setPtoDataLoaded(true);
                handleDateSortOnClick();
            })
    }

    const getPtoSnapshotInfo = () => {
        // let time = performance.now();
        axios.get(process.env.REACT_APP_API_URL + `/api/pto/getsnapshotbyuser/${details.UserId}`, AxiosConfig.configValue())
            .then((res: any) => {
                setPtoSnapshot(res.data.snapshot);
            })
            .catch((err: any) => {
                //console.log("Snapshot Error", err);
            })
    }

    const fetchStartingInfo = () => {
        setLoading(true);
        // const referenceData: any = {
        //     ...props.reference,
        // };
        setLoading(false);
        setLoaded(true);
    }

    const checkPtoPlan = () => {
        const userRef = props.userReference
        if (userRef?.ptoPlans) {
            for (let i = 0; i < userRef.ptoPlans.length; i++) {
                if (userRef.ptoPlans[i].id === userInfo.PTOPlanId) {
                    setUsersPTOPlan(userRef.ptoPlans[i]);
                    if (userInfo.PTOPlanId !== 11) {
                        setHasPtoPlan(true)
                    }
                }
            }
        }
    }

    const refreshUser = () => {
        axios.get(process.env.REACT_APP_API_URL + "/api/user/getSingleUser/" + details.UserId, AxiosConfig.configValue())
            .then((res: any) => {
                setUserInfo(res.data?.users[0]);
                setUserLoading(false);
                getPtoInfo()
            })
            .catch((err: any) => {
                //console.log("Refresh User Error", err);
            })
    }

    const refreshPTOInfo = () => {
        setRefreshing(true);
        axios.get(process.env.REACT_APP_API_URL + `/api/pto/detail/${details.UserId}`, AxiosConfig.configValue())
            .then((res: any) => {
                if (AxiosConfig.checkResponse(res, { alertOnSuccess: process.env.REACT_APP_SHOW_PTO_REFRESH === "true", successMessage: "PTO Data Refreshed" })) {
                    setPtoData(res.data.detail);
                }
            })
            .catch((err: any) => {
                AxiosConfig.handleError(err);
            })
            .finally(() => {
                setRefreshing(false);
                getArchivePTO(fromToDate)
            })
    }

    const openEditLedger = async (e: React.MouseEvent<HTMLButtonElement>, ledger: LedgerType) => {
        e?.preventDefault();
        await highlightTableRowById("request-table", `row-${ledger.ledgerId}`, true);
        setLedgerEdit(ledger);
    }

    const deleteLedgerModal = (entry: LedgerType, tableId: string = "requests-table") => {
        setEntryToDelete(entry);
        setRequestString(tableId);
        setShowPTODeletePrompt(!showPTODeletePrompt);
    }

    const deleteLedgerEntry = (entryToDelete: LedgerType, tableId: string = "requests-table") => {
        setIsUpdating(true);
        let updatedEntry: LedgerType = { ...entryToDelete };
        let ledgerCopy: Array<LedgerType> = [...ptoData.ledger];
        updatedEntry.deletedDatets = Date.now();
        axios.post(process.env.REACT_APP_API_URL + "/api/pto/ledger", updatedEntry, AxiosConfig.configValue("min"))
            .then((res: any) => {
                if (AxiosConfig.checkResponse(res, { alertOnSuccess: true, successMessage: "Updated Ledger Entry!", showSnackbar: true, snackBar: { manual: true } })) {
                    const index = ledgerCopy.findIndex((l: LedgerType) => l.ledgerId === entryToDelete?.ledgerId);
                    if (index > -1) {
                        ledgerCopy.splice(index, 1);
                        setLedgerEdit(null);
                        sortableData = ledgerCopy;
                    }
                }
                setShowPTODeletePrompt(false);
                setIsUpdating(false);
                setPtoData({ ...ptoData, ledger: ledgerCopy });
            })
            .catch((err: any) => {
                AxiosConfig.handleError(err);
            })
            .finally(() => {
                getArchivePTO(fromToDate)
            })
    }

    const handleLedgerStatusChange = (ledgerEntry: LedgerType, ptoData?: {
        ledger: Array<LedgerType>;
        pending: Array<number>;
        snapshot: PTOSnapshotType;
        ArchivedYears: string[];
    }, closeTooltip?: any) => {
        setIsUpdating(true);
        if (ledgerEntry) {
            let updatedEntry: LedgerType = { ...ledgerEntry };
            updatedEntry.quantity = Number(updatedEntry.quantity);
            updatedEntry.managerComment = ledgerEntry.managerComment
            //console.log(updatedEntry)
            axios.post(process.env.REACT_APP_API_URL + "/api/pto/ledger", updatedEntry, AxiosConfig.configValue("min"))
                .then((res: any) => {
                    if (AxiosConfig.checkResponse(res, { alertOnSuccess: true, successMessage: "Updated Ledger Entry!", showSnackbar: true, snackBar: { manual: true } })) {
                        if (ptoData) {
                            if (sortableData !== null && sortableData !== undefined) {
                                let sortableDataCopy: Array<LedgerType> = sortableData;
                                for (let j = 0; j < sortableDataCopy?.length; j++) {
                                    if (sortableDataCopy[j].ledgerId === updatedEntry.ledgerId) {
                                        sortableDataCopy[j] = res.data.LedgerEntry
                                    }
                                }
                                setPtoData({ ...ptoData, ledger: sortableDataCopy });
                            }
                        }
                    }
                    setShowLedgerStatusChangeModal(false);
                })
                .catch((err: any) => {
                    AxiosConfig.handleError(err);
                })
                .finally(() => {
                    axios.get(process.env.REACT_APP_API_URL + `/api/pto/getarchivedyear/${details.UserId}/${fromToDate}`, AxiosConfig.configValue())
                        .then((res) => setArchivedPTO(res.data.Data))
                    setIsUpdating(false);
                })

        } else {
            setIsUpdating(false);
        }
    }

    const handleShowLedgerStatusChange = (e: any, ledgerEntry: LedgerType, statusType: string) => {
        e.stopPropagation();
        setEntryToEdit(ledgerEntry);
        setLedgerStatusChangeType(statusType);
        setShowLedgerStatusChangeModal(!showLedgerStatusChangeModal);
    }

    const openContactSupportMessage = () => {
        setShowContactSuportMessage(!showContactSupportMessage);
    }

    // const closeEmployeeModal = () => {
    //     setEmployeeOpen(false);
    //     refreshUser();
    // }

    const handleApproveAllClick = (e: any) => {
        e.preventDefault();
        ptoData.ledger.forEach((ledger: LedgerType) => {
            if (ledger.status === "Pending" && (ledger.ledgerEntryTypeId === 4 || ledger.ledgerEntryTypeId === 5)) {
                let quantity = ledger.quantity;
                if (ledger.quantity) {
                    totalHours += quantity;
                }
            }
        });
        setShowApproveAllModal(!showApproveAllModal);
        return;
    }

    const approveAllModal = () => {
        return (
            <>
                <Modal.Header>
                </Modal.Header>
                <Modal.Body >
                    {
                        loading ?
                            <>
                                <div className="d-flex flex-row">
                                    <Spinner size="sm" animation="border" className="mr-3 mt-1" />
                                    <h5 className="mb-2" >Approving Hours</h5>
                                </div>
                            </>
                            : <h5>Are you sure that you want to approve all {Math.abs(ptoData?.snapshot?.TotalHoursPending + ptoData?.snapshot?.TotalUnpaidHoursPending)} hours?</h5>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-outline-danger" onClick={handleApproveAllClick}>No</button>
                    <button className="btn btn-outline-primary" onClick={affirmativeApproveAllClick}>Yes</button>
                </Modal.Footer>
            </>
        )
    }

    const affirmativeApproveAllClick = () => {
        setLoading(true);
        approveAllRequested();
        return;
    }

    const approveAllRequested = async () => {
        let calls: Array<any> = [];
        let errors: Array<PtoErrorType> = [];
        ptoData.ledger?.forEach((ledger: LedgerType) => {
            if (ledger.status === "Pending" && (ledger.ledgerEntryTypeId === 4 || ledger.ledgerEntryTypeId === 5)) {
                const updatedEntry: LedgerType = { ...ledger, status: "Approved" };
                totalHours += updatedEntry.quantity;
                calls.push(axios.post(process.env.REACT_APP_API_URL + "/api/pto/ledger", updatedEntry, AxiosConfig.configValue("min")))
            }
        });
        if (calls.length) {
            axios.all(calls)
                .then((responses: any) => {
                    if (AxiosConfig.checkResponse(responses, { alertOnSuccess: true, successMessage: "Approved Requested Time.", snackBar: { manual: true } })) {
                    }
                    for (let i = 0; i < responses.length; i++) {
                        if (responses[i].data.Error.success === true) {
                            handlePTOLedgerUpdate(responses[i], "Approved");
                        } else {
                            //@ts-ignore
                            errors.push({ date: responses[i].data.PTOLedger.entryDatets, errorMessage: responses[i].data.Error.message })
                            setPTOApprovalErrorList(errors)
                            setShowPTOErrorMessage(!showPTOErrorMessage);
                        }
                    }
                })
                .catch((err) => {
                    AxiosConfig.handleError(err);
                })
                .finally(() => {
                    sortableData = sortableDataCopy;
                    setShowApproveAllModal(!approveAllModal);
                    setLoading(false);
                    getPtoSnapshotInfo();
                    refreshUser();
                    refreshPTOInfo();
                })

        }
    }

    //cgm 042822 =>> for updating the ledger array without having to call the api again.
    const handlePTOLedgerUpdate = (ledgerItem: any, status: string) => {
        if (ledgerItem.status === 200) {
            if (sortableData !== undefined && sortableData !== null) { sortableDataCopy = sortableData }
            for (let j = 0; j < sortableDataCopy?.length; j++) {
                if (sortableDataCopy[j].ledgerId === ledgerItem.data.LedgerEntry.ledgerId) {
                    sortableDataCopy[j].status = status
                }
            }
        }
    }
    const getArchivePTO = (date: number | null) => {
        axios.get(process.env.REACT_APP_API_URL + `/api/pto/getarchivedyear/${details.UserId}/${date}`, AxiosConfig.configValue())
            .then((res) => (setArchivedPTO(res.data.Data)))
    }
    React.useEffect(() => {
        getPtoSnapshotInfo();
        //r-18-lint-cm
        //eslint-disable-next-line
    }, [sortableData, ptoData])

    React.useEffect(() => {
        refreshUser();
        fetchStartingInfo();
        //r-18-lint-cm
        //eslint-disable-next-line
    }, []);

    React.useEffect(() => {
        // usersPTOPlan.PTOPlanName && setHasPtoPlan(true);
        checkPtoPlan();
        //r-18-lint-cm
        //eslint-disable-next-line
    }, [userInfo.PTOPlanId])

    const handleCloseMissingPTOWarning = () => {
        setShowMissingPtoPlanModal(!showMissingPtoPlanModal);
    }
    React.useEffect(() => {
        getArchivePTO(fromToDate)
        //r-18-lint-cm
        //eslint-disable-next-line
    }, [fromToDate])
    const missingPtoPlan = () => {
        return (
            <>
                <Modal.Header>
                </Modal.Header>
                <Modal.Body >
                    <h5>Must assign PTO Plan to employee before requesting time</h5>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-outline-primary" onClick={handleCloseMissingPTOWarning}>Close</button>
                </Modal.Footer>
            </>
        )
    }

    //cgm040722 =>> generating negative or positive value to multiply date sort by in ledger
    const handleDateSortOnClick = () => {
        setDateSort(!dateSort);
        sortableData = ptoData?.ledger
        let approvalHours = 0;
        sortableData?.forEach((element) => {
            if (element.status === "Pending") {
                approvalHours += element.quantity
            }
        })
        setHoursToApprove(approvalHours);
    }

    //cgm 041122 =>> setting up date data for sorting ledger by date
    // let filteredData: LedgerType[] | null | undefined = ptoData?.ledger;
    // let startDate = moment(fromToDate).utcOffset(0);
    // const endDate = moment(startDate).add(1, "years")

    const setFilteredDataByDate = (data: PTOArchiveType[]) => {
        // let filtereableData = sortableData?.filter(
        //     function (data) {
        //         return (data.entryDatets) > Number(startDate) && (data.entryDatets) < Number(endDate);
        //     }
        // );
        return dateSort ?
            data?.sort((a: PTOArchiveType, b: PTOArchiveType) => (a.EntryDate > b.EntryDate ? 1 : -1))
            : data?.sort((a: PTOArchiveType, b: PTOArchiveType) => a.EntryDate > b.EntryDate ? -1 : 1)
    }

    //cgm 041122 =>> Setting up types for Entry dropdown and filtering ledger by entry type
    let entryTypes: Array<{ label: string, value: number }> = [];
    entryTypes.push({ label: "All", value: -1 });
    ledgerEntryTypes &&
        ledgerEntryTypes.map((entry: any) => entryTypes.push({ label: entry.text, value: entry.id }));

    const handleLedgerEntryTypeChange = (val: any) => {
        setEntryType(val);
    }

    const handleTypeFilter = (filteredData: PTOArchiveType[]) => {
        if (entryType?.value === -1) {
            return filteredData;
        }
        return filteredData.filter(
            function (data) {
                return (data.PTOLedgerEntryTypeId === entryType?.value)
            }
        )
    }

    //cgm 041122 =>> Needed for filtering ledger items based on date or type  

    //cgm 060222 =>> tooltips for the top right icons like expand and toggle verticle


    // React.useEffect(() => {
    //     // if(filteredEntries !== undefined && loading !== true) {
    //     //     handleDateSortOnClick();
    //     // } 
    // }, [filteredEntries])


    const topCornerSettingTooltips = (tooltipString: string) => {
        return (
            <ReactTooltip id={`pto-${tooltipString}-tooltip`}>
                {tooltipString}
            </ReactTooltip>
        )
    }

    //cgm 060122 =>> returns array of conflicts with requested days off for total requested warning.
    const findConflictsInRequests = (ptoArray: LedgerType[]) => {
        ptoArray?.forEach(element => {
            if (element.CalendarConflicts !== undefined && element.CalendarConflicts?.length > 0) {
                for (let i = 0; i < element.CalendarConflicts.length; i++) {
                    conflictArray?.push(element.CalendarConflicts[i])
                }
            }
            setPTORequestConflicts(conflictArray);
        });
    }

    React.useEffect(() => {
        if (sortableData !== undefined && sortableData !== null) {
            findConflictsInRequests(sortableData);
        }
        //r-18-lint-cm
        //eslint-disable-next-line
    }, [ptoData])

    // const created = (created: number | string, modified: number | string) => {

    // }

    const createdByToolTip = (ledgerItem: LedgerType) => {
        let creationDate = dayjs.utc(ledgerItem.createdDatets);
        let modifiedDate = dayjs.utc(ledgerItem.statusSetDateUTCts);
        return (
            <Popover id="pto-created-by-tooltip">
                <CreateDatePopover
                    ledgerItem={ledgerItem}
                    creationDate={creationDate}
                    modifiedDate={modifiedDate}
                />
            </Popover>
        )
    }

    //cgm =>> popover for viewing pto comments
    const ArchivetoLedger = (archive: PTOArchiveType) => {

        let ledger = {
            ManagerCommentDatets: archive.ManagerCommentDateUTC ? moment.utc(archive.ManagerCommentDateUTC).valueOf() : null,
            EmployeeCommentDatets: archive.EmployeeCommentDateUTC ? moment.utc(archive.EmployeeCommentDateUTC).valueOf() : null,
            ManagerCommenterName: archive.ManagerCommenterName,
            EmployeeCommenterName: archive.EmployeeCommenterName,
            employeeComment: archive.EmployeeComment,
            managerComment: archive.ManagerComment,
            createdByDisplayName: archive.CreatedByDisplayName,
            statusSetByDisplayName: archive.StatusSetByDisplayName,
            status: archive.PTOStatus,
            deletedDatets: archive.DeletedDateUTC ? moment.utc(archive.DeletedDateUTC).valueOf() : null,
            endTimets: archive.EndTimeUTC ? moment.utc(archive.EndTimeUTC).valueOf() : null,
            entryDatets: archive.EntryDate ? moment.utc(archive.EntryDate).valueOf() : null,
            ledgerEntryTypeId: archive.PTOLedgerEntryTypeId,
            ledgerId: archive.PTOLedgerId,
            planId: archive.PTOPlanId,
            quantity: archive.Quantity,
            startTimets: archive.StartTimeUTC ? moment.utc(archive.StartTimeUTC).valueOf() : null,
            userId: archive.EmployeeId,
            utcOffset: archive.UTCOffset ? Number(archive.UTCOffset) : 0,
            timeEntryId: archive.TimeEntryID,
            createdBy: archive.CreatedBy,
            createdDatets: moment.utc(archive.CreatedDateUTC).valueOf(),
            modifiedBy: archive.ModifiedBy,
            modifiedDatets: archive.ModifyDateUTC ? moment.utc(archive.ModifyDateUTC).valueOf() : null,
            IsUnplanned: archive.IsUnplanned
        } as LedgerType
        return ledger
    }
    const showComment = (ledgerItem: LedgerType, employee: boolean) => {
        let employeeCommentDate = dayjs.utc(ledgerItem.EmployeeCommentDatets);
        let managerCommentDate = dayjs.utc(ledgerItem.ManagerCommentDatets)
        return (
            <Popover id="pto-comment-popover">
                <PTOShowComment
                    ledgerItem={ledgerItem}
                    employee={employee}
                    employeeCommentDate={employeeCommentDate}
                    managerCommentDate={managerCommentDate}
                />
            </Popover>
        )
    }

    //cgm 060122 =>> popover for the list of ptoconflicts
    const showConflictList = (conflictArray: CalendarConflictType[]) => {
        return (
            <Popover id="pto-conflict-list-warning">
                <CalendarConflictWarningList
                    conflictArray={conflictArray}
                />
            </Popover>
        )
    }

    //cgm 051022 =>> comment icon display 
    const commentIcon = (row: LedgerType, employee: boolean) => (
        <div className="employee-comment-div">
            {
                employee ? //employee comment
                    <i className={`material-icons ${row.employeeComment ? "bg-white text-primary" : "bg-white icon-text-color"}`}>
                        3p
                    </i>
                    : //manager comment
                    <i className={`material-icons ${row.managerComment ? "bg-white text-primary" : "bg-white icon-text-color"}`}>
                        announcement
                    </i>
            }
        </div>
    )

    //cgm092222==> Fixing a bug where I was calling checkPTOPlan on line 584 if the plan was missing.  Stack overflow link below for more info
    // https://stackoverflow.com/questions/62336340/cannot-update-a-component-while-rendering-a-different-component-warning
    React.useEffect(() => {
        checkPtoPlan();
        //r-18-lint-cm
        //eslint-disable-next-line
    }, [usersPTOPlan?.text])
    return (
        <div className="ManagePTODetail">{/****bk 30/30/2022 => add className for PTODecoupler stylesheet*******/}

            {!props.hideHeader && <CollapsibleArea
                Toggle={({ onClick, open }: any) => {
                    return (
                        <div className="d-flex align-items-center">
                            <i onClick={onClick} className="material-icons mr-1 action-text">{open ? "remove_circle_outline" : "add_box"}</i>
                            {/* <EmployeeBadge employeeId={userInfo.UserId} size={33} /> */}
                            {loaded &&
                                <span className='mobile-hide '><EmployeeBadge employeeId={userId} size={33} /></span>}
                            {/* <h5>{details.DisplayName} | {loading ? <Spinner size="sm" animation="border" /> : userInfo.EmployeeNumber}</h5> */}
                            <h5>{details.DisplayName} | {details.UserNumber}</h5>
                            <span className="text-secondary ml-2 h5 d-flex align-items-center"> {
                                userLoading === true ?
                                    <Spinner size="sm" animation="border" className="ml-auto" /> :
                                    usersPTOPlan?.text
                                        ? <span className='mobile-hide '>{"Plan: " + usersPTOPlan?.text}</span>
                                        : <><i className="material-icons text-warning">warning</i> Missing Plan</>
                            }  </span>
                            {
                                loading || refreshing
                                    ? <Spinner size="sm" animation="border" className="ml-auto" /> :
                                    // :<i className="material-icons action-text ml-auto p-1" onClick={() => refreshPTOInfo()}>refresh</i>
                                    <OverlayTrigger trigger={["hover", "focus"]} placement="top" overlay={topCornerSettingTooltips("Reload")}>
                                        <i className="material-icons action-text ml-auto p-1" onClick={() => refreshPTOInfo()}>refresh</i>
                                    </OverlayTrigger>
                            }
                            <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={topCornerSettingTooltips("Toggle-Orientation")}>
                                <button onClick={toggleVertical} className={`action-text material-icons ${isVertical ? "rotate-90" : ""}`}>
                                    swap_horiz
                                </button>
                            </OverlayTrigger>
                            <OverlayTrigger trigger={["hover", "focus"]} placement="top" overlay={topCornerSettingTooltips("Expand")}>
                                <i className="material-icons action-text p-1" onClick={toggleModal}>fit_screen</i>
                            </OverlayTrigger>
                            <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={topCornerSettingTooltips("Help")}>
                                <div>
                                    {/* <Tooltip iconClassName='text-info' placement='left' name="TT-PTO-Details-Icons" /> */}
                                </div>
                            </OverlayTrigger>
                            <OverlayTrigger trigger={["hover", "focus"]} placement="top" overlay={topCornerSettingTooltips("Close")}>
                                <i className="material-icons action-text-danger p-1" onClick={handleClose}>close</i>
                            </OverlayTrigger>
                        </div>)
                }}
                startOpen
            >
                <div className="d-flex justify-content-center pl-1">
                    <div className="col-md-6">
                        <div className="">
                            <span className="mobile-hide font-weight-bold mr-2">Department </span>
                            {/* <span>{userInfo.HomeDepartmentId} | {userInfo.HomeDepartment}</span> */}
                            <span className="mobile-hide" >{userInfo.HomeDepartmentId} | {userLoading ? <Spinner size="sm" animation="border" /> : userInfo.HomeDepartment}</span>
                        </div>
                        <div className="">
                            <span className="mobile-hide font-weight-bold mr-2">Position </span>
                            {/* <span>{userInfo.OccupationTypeDesc} | {userInfo.JobTitle}</span> */}
                            <span className="mobile-hide" >{userInfo.OccupationTypeDesc} | {userLoading ? <Spinner size="sm" animation="border" /> : userInfo.JobTitle}</span>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="">
                            <span className="mobile-hide font-weight-bold mr-2">Division </span>
                            {/* <span>{userInfo.HomeProfitCenterId} | {userInfo.HomeProfitCenter}</span> */}
                            <span className='mobile-hide' >{userInfo.HomeProfitCenterId} | {userLoading ? <Spinner size="sm" animation="border" /> : userInfo.HomeProfitCenter}</span>
                        </div>
                        <div className="">
                            <span className="mobile-hide font-weight-bold mr-2">Status </span>
                            {/* <span>{userInfo.EmploymentStatus}</span> */}
                            <span className='mobile-hide' >{userLoading ? <Spinner size="sm" animation="border" /> : userInfo.EmploymentStatus}</span>
                        </div>
                    </div>
                </div>
            </CollapsibleArea>}

            {
                !ptoDataLoaded ?
                    <div className="d-flex justify-content-center align-items-center">
                        <Loader title="Loading PTO Data" />
                    </div>
                    :
                    <>
                        <div className="ManageDetailPTOInfo">
                            <h5>PTO Information</h5>
                            <StaticInfoPanel/>
                        </div>

                        <div className="ManageDetailPTOBalanceInfo">
                            <div className="ManageDetailPTOBalanceInfoItem">
                                <div className="ManageDetailPTOBalanceInfoItemHeader">
                                    <div className="ManageDetailPTOBalanceInfoItemHeaderLeft">
                                        <p>PTO Balance</p>
                                    </div>
                                    <div className="ManageDetailPTOBalanceInfoItemHeaderRight">

                                    </div>
                                </div>
                                <div className="ManageDetailPTOBalanceInfoItemBody">
                                    <FormControl
                                        value={ptoSnapshot?.CurrentBalance}
                                        type="text"
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            {/* {isHrAdmin && <div className="ManageDetailPTOBalanceInfoItem"> */}
                            <div className="ManageDetailPTOBalanceInfoItem">
                                <div className="ManageDetailPTOBalanceInfoItemHeader">
                                    <div className="ManageDetailPTOBalanceInfoItemHeaderLeft">
                                        <p>PTO Balance</p>
                                        <p className="ManageDetailPTOBalanceInfoItemHeaderTextGray">(last check)</p>
                                    </div>
                                    <div className="ManageDetailPTOBalanceInfoItemHeaderRight">

                                    </div>

                                </div>
                                <div className="ManageDetailPTOBalanceInfoItemBody">
                                    <FormControl
                                        value={ptoSnapshot?.CurrentBalanceExportedYTD}
                                        type="text"
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="ManageDetailPTOBalanceInfoItem">
                                <div className="ManageDetailPTOBalanceInfoItemHeader">
                                    <div className="ManageDetailPTOBalanceInfoItemHeaderLeft">
                                        <p>Actual to date</p>
                                    </div>
                                    <div className="ManageDetailPTOBalanceInfoItemHeaderRight">

                                    </div>
                                </div>
                                <div className="ManageDetailPTOBalanceInfoItemBody">
                                    <FormControl
                                        value={ptoSnapshot?.CurrentBalanceYTD}
                                        type="text"
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="ManageDetailPTOBalanceInfoItem">
                                <div className="ManageDetailPTOBalanceInfoItemHeader">
                                    <div className="ManageDetailPTOBalanceInfoItemHeaderLeft">
                                        <p>Total requested</p>
                                        <p className="ManageDetailPTOBalanceInfoItemHeaderTextGray">(hours)</p>
                                    </div>
                                    <div className="ManageDetailPTOBalanceInfoItemHeaderRight">
                                        {
                                            (ptoRequestConflicts !== undefined && ptoRequestConflicts?.length > 0) &&
                                            <OverlayTrigger trigger={["hover", "focus"]} placement="left" delay={400} overlay={showConflictList(ptoRequestConflicts)} >
                                                <i id="manage-detail-pto-balance-item-conflicts-warning-icon" className="material-icons text-danger">warning</i>
                                            </OverlayTrigger>
                                        }
                                    </div>
                                </div>
                                <div className="ManageDetailPTOBalanceInfoItemBody">
                                    <div className={`ManageDetailPTOBalanceInfoItemBodyApprovePTO ${canApprove ? "ManageDetailPTOBalanceInfoItemBodyApprovePTOCanApprove" : "ManageDetailPTOBalanceInfoItemBodyApprovePTOCantApprove"}`}>
                                        <FormControl
                                            value={requested}
                                            type="text"
                                            disabled={true}
                                        />
                                    </div>
                                    {!isOwnPTO && <Button
                                        disabled={!canApprove}
                                        variant={`${canApprove ? "success" : "secondary"}`}
                                        onClick={ptoSnapshot?.TotalHoursPending ? handleApproveAllClick : () => null}
                                    >
                                        Approve
                                    </Button>}
                                </div>
                            </div>
                        </div>

                        <CollapsibleArea //PTO Information            
                            Toggle={({ onClick, open }: any) => {
                                return (
                                    <div className="d-flex align-items-center mt-1">
                                        <i onClick={onClick} className="material-icons mr-1 action-text">{open ? "remove_circle_outline" : "add_box"}</i>
                                    </div>
                                )
                            }}
                            startOpen={false}
                        >
                            <div className="d-flex flex-wrap">
                                <div className="col-sm-12 col-md-6">
                                    <span className="font-weight-bold mr-2">PTO Carried over from {dayjs().year() - 1} <span className="text-secondary">&#40;hours&#41;</span></span>
                                    <TextInput className="mt-2 mb-2" disabled value={ptoSnapshot?.RolloverAmount || 0} />
                                </div>
                                <div className="col-sm-12 col-md-6">
                                    <span className="font-weight-bold mr-2">Total PTO Adjustments <span className="text-secondary">&#40;hours&#41;</span></span>
                                    <TextInput className="mt-2 mb-2" disabled value={ptoSnapshot?.TotalAdjustments || 0} />
                                </div>
                                <div className="col-sm-12 col-md-6">
                                    <span className="font-weight-bold mr-2">YTD PTO Accruals <span className="text-secondary">&#40;hours&#41;</span></span>
                                    <TextInput className="mt-2 mb-2" disabled value={ptoSnapshot?.YTDPTOAccrual || 0} />
                                </div>
                                <div className="col-sm-12 col-md-6">
                                    <span className="font-weight-bold mr-2">Next PTO Accrual <span className="text-secondary">&#40;hours&#41;</span></span>
                                    <TextInput className="mt-2 mb-2" disabled value={ptoSnapshot?.NextAccrualHours || 0} />
                                </div>
                                <div className="col-sm-12 col-md-6">
                                    <span className="font-weight-bold mr-2">Total Approved Paid <span className="text-secondary">&#40;hours&#41;</span></span>
                                    <TextInput className="mt-2 mb-2" disabled value={Math.abs(ptoSnapshot?.TotalHoursUsed) || 0} />
                                </div>
                                <div className="col-sm-12 col-md-6">
                                    <span className="font-weight-bold mr-2">Total PTO Possible <span className="text-secondary">&#40;hours&#41;</span></span>
                                    <TextInput className="mt-2 mb-2" disabled value={ptoSnapshot?.TotalHoursPossible} />
                                </div>
                                <div className="col-sm-12 col-md-6">
                                    <span className="font-weight-bold mr-2">Total Approved Unpaid <span className="text-secondary">&#40;hours&#41;</span></span>
                                    <TextInput className="mt-2 mb-2" disabled value={Math.abs(ptoSnapshot?.TotalUnpaidHoursUsed) || 0} />
                                </div>
                            </div>
                        </CollapsibleArea>
                        <hr style={{ borderBottom: "1px solid lightgrey" }} />
                        {
                            showLedgerStatusChangeModal &&
                            <LedgerStatusChange
                                ledgerStatusTypes={props.ledgerReference?.ledgerStatusTypes}
                                ledgerEntry={entryToEdit}
                                changeType={ledgerStatusChangeType}
                                saving={saving}
                                showLedgerStatusChangeModal={showLedgerStatusChangeModal}
                                setShowLedgerStatusChangeModal={setShowLedgerStatusChangeModal}
                                setShowPtoStatusChangeModal={setShowPtoStatusChangeModal}
                                handleLedgerStatusChange={handleLedgerStatusChange}
                                isOwnPTO={isOwnPTO}
                                ptoData={ptoData}
                                isUpdating={isUpdating}
                            />
                        }
                        {
                            ptoDataLoaded &&
                            <PTORequestTable
                                handleLedgerStatusChange={handleLedgerStatusChange}
                                setPtoData={setPtoData}
                                ptoData={ptoData}
                                ptoSnapShot={ptoSnapshot}
                                ledgerReference={props.ledgerReference}
                                openEditLedger={openEditLedger}
                                setAddLedgerOpen={setAddLedgerOpen}
                                // table data only only shows positive amounts for everything except adjustments which aren"t shown anyways on this table.  May remove this later???
                                tableData={ptoData.ledger?.map((entry: any) => ({ ...entry, quantity: entry.ledgerEntryTypeId === 2 ? entry.quantity : Math.abs(entry.quantity) })) || []}
                                updatePTOData={refreshPTOInfo}
                                isOwnPTO={isOwnPTO}
                                isInactive={userInfo.Inactive}
                                manageUpdating={isUpdating}
                                hasPtoPlan={hasPtoPlan}
                                showMissingPtoPlanModal={showMissingPtoPlanModal}
                                setShowMissingPtoPlanModal={setShowMissingPtoPlanModal}
                                loading={loading}
                                openContactSupportMessage={openContactSupportMessage}
                                userInfo={userInfo}
                                showContactSuportMessage={showContactSupportMessage}
                                setShowContactSuportMessage={setShowContactSuportMessage}
                                showLedgerStatusChangeModal={showLedgerStatusChangeModal}
                                setShowLedgerStatusChangeModal={setShowLedgerStatusChangeModal}
                                setShowPtoStatusChangeModal={setShowPtoStatusChangeModal}
                                showPtoStatusChangeModal={showPtoStatusChangeModal}
                                handleShowLedgerStatusChange={handleShowLedgerStatusChange}
                                saving={saving}
                                sortableData={sortableData}
                                handlePTOLedgerUpdate={handlePTOLedgerUpdate}
                                handleDateSortOnClick={handleDateSortOnClick}
                                deleteLedgerModal={deleteLedgerModal}
                                createdByToolTip={createdByToolTip}
                                refreshLedgerEntries={() => getArchivePTO(fromToDate)}
                            />
                        }

                        <hr style={{ borderBottom: "1px solid lightgrey" }} />
                        <ErrorBoundary showError>
                            <CollapsibleArea // Ledger Table
                                Toggle={({ onClick, open }: any) => {
                                    return (
                                        <div className="d-flex align-items-center">
                                            <i onClick={onClick} className="material-icons mr-1 action-text">{open ? "remove_circle_outline" : "add_box"}</i>
                                            <h5>Ledger Entries | <span className="text-secondary">PTO Plan:
                                                {usersPTOPlan?.text || "No Plan"}</span></h5>
                                        </div>
                                    )
                                }}
                                startOpen={false}
                            >
                                <div className="d-flex ">
                                    <Table id="ledger-table">
                                        <thead>
                                            <tr>

                                                <th id="ledger-date-header" >
                                                    <div className="ledger-date-outer-div d-flex flex-row">
                                                        <div onClick={handleDateSortOnClick} className="ledger-date-div flex-row" >
                                                            Date
                                                        </div>
                                                        <span onClick={handleDateSortOnClick} className="date-sort-icon material-icons">
                                                            unfold_more
                                                        </span>
                                                    </div>
                                                    <div id="ledger-date-header-select-wrapper">
                                                        <LedgerYearFilterSelect
                                                            ptoData={ptoData}
                                                            startDate={fromToDate}
                                                            setFromToDate={setFromToDate}
                                                            loading={loading}
                                                        />
                                                    </div>
                                                </th>
                                                <th id="ledger-type-header">
                                                    <div id="type-div">
                                                        Type
                                                    </div>

                                                    <div id="ledger-type-header-select-wrapper" >
                                                        <Select
                                                            className="type-select"
                                                            options={
                                                                entryTypes?.map((entry: any) => ({ label: entry.label, value: entry.value }))
                                                            }
                                                            value={entryType}
                                                            onChange={(val: any) => handleLedgerEntryTypeChange(val)}
                                                        />
                                                    </div>
                                                </th>
                                                <th>Hours</th>
                                                <th>Unpaid Hours</th>
                                                <th>Status</th>
                                                <th className="centered">Employee Comment</th>
                                                <th className="centered">Manager Comment</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* //cgm040722 =>> conditional sorting by multiplying the sort value by negative 1 if Date is clicked */}
                                            {
                                                ArchivedPTO ?
                                                    setFilteredDataByDate(handleTypeFilter(ArchivedPTO))?.map((ledgerEntry: PTOArchiveType) => {
                                                        const isEditableType = props.ledgerReference?.ledgerEntryTypes?.find((ledgerEntryType: LedgerReferenceType) => ledgerEntryType.id === ledgerEntry.PTOLedgerEntryTypeId) !== undefined;
                                                        return (
                                                            <tr key={ledgerEntry.PTOLedgerId} id={`row-${ledgerEntry.PTOLedgerId}`}>

                                                                <td>

                                                                    <OverlayTrigger trigger={["hover", "focus"]} placement="right" overlay={createdByToolTip(ArchivetoLedger(ledgerEntry))}>
                                                                        <div className="ledger-date-div">
                                                                            {ledgerEntry.EntryDate ? dayjs.utc(ledgerEntry.EntryDate).format("MM/DD/YYYY") : "Not Set"}
                                                                        </div>
                                                                    </OverlayTrigger>
                                                                </td>
                                                                <td>{
                                                                    ledgerEntry.PTOLedgerEntryTypeId === 1
                                                                        ? "Accrual"
                                                                        : ledgerEntry.PTOLedgerEntryTypeId === 2
                                                                            ? "Adjustments"
                                                                            : ledgerEntry.PTOLedgerEntryTypeId === 3
                                                                                ? "Carry Over"
                                                                                : props.ledgerReference?.ledgerEntryTypes?.find((ledgerEntryType: LedgerReferenceType) => ledgerEntryType.id === ledgerEntry.PTOLedgerEntryTypeId)?.text || "No Type"
                                                                }</td>
                                                                <td>{props.ledgerReference?.ledgerEntryTypes?.find((ledgerEntryType: LedgerReferenceType) => ledgerEntryType.id === ledgerEntry.PTOLedgerEntryTypeId)?.id !== 5 && ledgerEntry.Quantity}</td>
                                                                <td>{props.ledgerReference?.ledgerEntryTypes?.find((ledgerEntryType: LedgerReferenceType) => ledgerEntryType.id === ledgerEntry.PTOLedgerEntryTypeId)?.id === 5 && ledgerEntry.Quantity}</td>
                                                                <td title={ledgerEntry.PTOStatus === "Pending" ? "Requested" : ledgerEntry.PTOStatus}>
                                                                    {
                                                                        isEditableType
                                                                            ? isOwnPTO || fromToDate !== null || ledgerEntry.PayrollExportDateUTC !== null
                                                                                ? <i className={`material-icons ${ledgerEntry.PTOStatus === "Approved" ? "text-success" : ledgerEntry.PTOStatus === "Denied" ? "text-danger" : "text-warning"}`}>
                                                                                    {ledgerEntry.PTOStatus === "Approved"
                                                                                        ? "check_circle"
                                                                                        : ledgerEntry.PTOStatus === "Denied"
                                                                                            ? "cancel"
                                                                                            : "pending_actions"
                                                                                    }
                                                                                </i>
                                                                                :
                                                                                <i onClick={(e) => handleShowLedgerStatusChange(e, ArchivetoLedger(ledgerEntry), "ledgerChangeType")}
                                                                                    className={ledgerEntry.PTOStatus === "Approved" ? "text-success material-icons mr-1 action-text"
                                                                                        : ledgerEntry.PTOStatus === "Denied" ? "text-danger material-icons mr-1 action-text"
                                                                                            : "text-warning material-icons mr-1 action-text"}>
                                                                                    {ledgerEntry.PTOStatus === "Approved" ? "check_circle"
                                                                                        : ledgerEntry.PTOStatus === "Denied" ? "cancel"
                                                                                            : "pending_actions"}
                                                                                </i>
                                                                            : null
                                                                    }
                                                                </td>
                                                                <td className="centered">
                                                                    {ledgerEntry.EmployeeComment
                                                                        ?
                                                                        <OverlayTrigger trigger={["hover", "focus"]} placement="right" delay={400} overlay={showComment(ArchivetoLedger(ledgerEntry), true)} >
                                                                            {commentIcon(ArchivetoLedger(ledgerEntry), true)}
                                                                        </OverlayTrigger>
                                                                        : <> </>}
                                                                </td>
                                                                <td className="centered">
                                                                    {
                                                                        ledgerEntry.ManagerComment
                                                                            ?
                                                                            <OverlayTrigger trigger={["hover", "focus"]} placement="left" delay={400} overlay={showComment(ArchivetoLedger(ledgerEntry), false)} >
                                                                                {commentIcon(ArchivetoLedger(ledgerEntry), false)}
                                                                            </OverlayTrigger>
                                                                            : <> </>
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {
                                                                        (!isOwnPTO && isEditableType && !ledgerEntry.PayrollExportDateUTC) &&
                                                                        <>
                                                                            <i className="material-icons action-text-danger" onClick={(e: any) => {
                                                                                e.preventDefault();
                                                                                editLedgerForm.current = ledgerEntry;
                                                                                deleteLedgerModal(ArchivetoLedger(ledgerEntry), "ledger-table");
                                                                            }}>delete</i>
                                                                            <i className="material-icons action-text" onClick={(e: any) => openEditLedger(e, ArchivetoLedger(ledgerEntry))}>edit</i>
                                                                        </>
                                                                    }
                                                                    {   //cgm 050322 =>> if there isn"t a timeEntry ID and the pay type is PTO or unpaid PTO and the user is hourly show this message 

                                                                        ((ledgerEntry.TimeEntryID === 0 || ledgerEntry.TimeEntryID === null) && userInfo.PayTypeId === 1 && (ledgerEntry.PTOLedgerEntryTypeId === 4 || ledgerEntry.PTOLedgerEntryTypeId === 5)) ?
                                                                            <i className="material-icons action-text text-danger blink-me" onClick={(e: any) => openContactSupportMessage()}>
                                                                                warning
                                                                            </i>
                                                                            :
                                                                            // ledgerEntry.TimeEntryID === null &&
                                                                            // <i className="material-icons action-text text-danger blink-me" onClick={(e: any) => openContactSupportMessage()}>
                                                                            //     warning
                                                                            // </i>
                                                                            null
                                                                    }
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                    : loading ? <div className="d-flex w-100 align-items-center justify-content-center">
                                                        <Loader title="Loading Ledger Entries..." />
                                                    </div> : <span>No Data</span>
                                            }
                                        </tbody>
                                    </Table>
                                </div>
                            </CollapsibleArea>
                        </ErrorBoundary>
                    </>
            }
            {(!hasPtoPlan && showMissingPtoPlanModal) && missingPtoPlan()}
            <Modal show={showApproveAllModal} centered dialogClassName="missing-pto-plan-modal">
                {approveAllModal()}
            </Modal>
            <Modal show={showMissingPtoPlanModal} centered dialogClassName="missing-pto-plan-modal">
                {missingPtoPlan()}
            </Modal>
            {/* <Modal show={employeeOpen} centered size="xl" dialogClassName="manage-detail-customer-modal">
                <Modal.Body>
                    <EmployeeOverview
                        employee={userInfo}
                        closeDetailPanel={() => closeEmployeeModal()}
                        setActiveKey={() => null}
                        activeKey={"UserAdministration"}
                        setHeaderType={() => null}
                        headerType={"HeaderCollapsed"}
                        viewMode={"EmployeeOverview"}
                        setViewMode={() => null}
                    />
                </Modal.Body>
            </Modal> */}
            <Modal dialogClassName={showPtoWarningAlert ? "ptowarning-modal-dialog" : "pto-modal-dialog"} show={addLedgerOpen} centered>
                <h5 className="underline underline-on-hover">Request PTO</h5>
                <AddRequest
                    availableHours={ptoData.snapshot?.CurrentBalance}
                    usersPTOPlan={usersPTOPlan}
                    maxDailyPTOHours={details.MaxDailyPTOHours}
                    closeModal={() => setAddLedgerOpen(false)}
                    userInfo={userInfo}
                    ledgerReference={props.ledgerReference}
                    refreshPTOInfo={refreshPTOInfo}
                    showPtoWarningAlert={showPtoWarningAlert}
                    setShowPtoWarningAlert={setShowPtoWarningAlert}
                    sortablePtoData={sortableData}
                    ptoData={ptoData}
                    setPtoData={setPtoData}
                    isOwnPto={isOwnPTO}
                    getPtoSnapshotInfo={getPtoSnapshotInfo}
                />
            </Modal>
            <Modal show={ledgerEdit !== null} centered dialogClassName="pto-modal-dialog-edit">
                <h5 className="underline underline-on-hover">Edit PTO</h5>
                <EditRequest
                    availableHours={ptoData.snapshot?.CurrentBalance}
                    usersPTOPlan={usersPTOPlan}
                    maxDailyPTOHours={details.MaxDailyPTOHours}
                    closeModal={() => setLedgerEdit(null)}
                    userInfo={userInfo}
                    ledgerReference={props.ledgerReference}
                    refreshPTOInfo={refreshPTOInfo}
                    toEdit={ledgerEdit}
                    isOwnPTO={isOwnPTO}
                    sortablePtoData={sortableData}
                    ptoData={ptoData}
                    setPtoData={setPtoData}
                />
            </Modal>
            <PTOApprovalError
                showPTOErrorMessage={showPTOErrorMessage}
                setShowPTOErrorMessage={setShowPTOErrorMessage}
                ptoApprovalErrorList={ptoApprovalErrorList}
            />
            {
                <PTODeletePrompt
                    isUpdating={isUpdating}
                    showPTODeletePrompt={showPTODeletePrompt}
                    setShowPTODeletePrompt={setShowPTODeletePrompt}
                    setDeletePTOEntry={setDeletePTOEntry}
                    entryToDelete={entryToDelete}
                    deleteLedgerEntry={deleteLedgerEntry}
                    requestString={requestString}
                />
            }
        </div>
    )
}
const mapStateToProps = (state: AppState) => ({
    userId: state.user.userId,
    userReference: state.userReference.userReference
});

export default connect(mapStateToProps)(ManageDetail);